var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class FsrDvHsw {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`>>HDMI${value}`, /<<\s*HDMI(\d+)|<<(AUTO Switch)/i, tags);
                return match[1] ? match[1] : this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: {
                regExp: /<<\s*HDMI(\d+)/i,
                callback: (match) => {
                    this.state.videoMatrixRoutes.update('1', match[1]);
                },
            },
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    const tags = ['poll'];
                    yield this.socket.send(`>>SYSInfo`, /<<\s*V(?:ER)?\s+([\d\.]+)/i, tags);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socket.send(`${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? '>>AUTO' : '>>MANUAL'}`, /<<\s*(AUTO|MANUAL)\s+Switch/i, ['configure']);
            const match = yield this.socket.send(`>>SYSInfo`, /<<\s*V(?:ER)?\s+([\d\.]+)/i, [
                'configure',
            ]);
            if (match) {
                this.state.firmwareVersion.update(match[1]);
            }
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const initializerSteps = [
                {
                    errorCode: 'verifyFailed',
                    send: '>>SYSInfo',
                    next: /<<\s*HDMI(\d+)/i,
                },
            ];
            return yield CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
        });
    }
}
// static properties
FsrDvHsw.driverType = 'socketDriver';
FsrDvHsw.key = '-NXLDUi88xVZaQE6j2E6';
FsrDvHsw.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r\n',
};
FsrDvHsw.socketOptions = [
    Object.assign(Object.assign({}, FsrDvHsw.baseSocketOptions), { port: 4999 }),
];
